import createReactComponent from '../createReactComponent';
export default createReactComponent('ease-in', 'IconEaseIn', [
  ['path', { d: 'M3 20c8 0 18 -16 18 -16', key: 'svg-0' }],
]);
